/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import NumberFormat from 'react-number-format';
import {
  formatCurrency,
  parseCurrency,
} from '@brazilian-utils/brazilian-utils';
import { useState, useEffect } from 'react';
import { InputStyled } from './styles';

interface IInformValue {
  onClick: any;
  qtyInput: number;
}

const InformValue: React.FC<IInformValue> = ({ onClick, qtyInput }) => {
  const [valueChange, setValueChange] = useState('');

  useEffect(() => {
    setValueChange(formatCurrency(qtyInput || 0));
  }, [qtyInput]);
  return (
    <>
      <div
        style={{
          marginTop: 20,
        }}
      >
        <InputStyled
          placeholder="Digite aqui"
          value={`R$ ${valueChange}`}
          onChange={e => {
            const parsed = parseCurrency(e.target.value);

            setValueChange(formatCurrency(parsed));

            onClick({
              floatValue: parsed,
            });
          }}
        />
      </div>
    </>
  );
};

export { InformValue };
